import React, {useEffect, useState} from 'react'
import {Link, useHistory} from 'react-router-dom';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
} from 'reactstrap';
import { useDispatch } from 'react-redux';
import { axiosWithAuth } from '../utils/axiosWithAuth';
import styled from 'styled-components';
import { LOGOUT, LOG_IN, LOADING, LOADING_OFF, ERROR } from '../store/actions/UserAction';

const StyledNavbar = styled(Navbar)`
    background: white;
    opacity: ${props => props.navSetting ? .93 : 1};
    display: flex;
    flex-direction: column;
    border-bottom: 1.5px grey solid;
    @media (max-width: ${props => props.theme.mobileBreakpoint}){
        padding-top:7%;
        padding-left:  3%;
    }
`

const Div = styled.div`
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-start;
`

const StyledNavItem = styled(NavItem)`
    margin-top: 3%;
    margin-bottom: 3%;
    @media (min-width: ${props => props.theme.tabletBreakpoint}){
        margin-right: 25%;
        margin-left: 25%;
    }
    /* @media (min-width: ${props => props.theme.mobileBreakpoint}){
        margin-right: 0%;
        margin-left: 0%;
    } */
    white-space: nowrap;
`

const NavBar = () => {
    const history = useHistory()
    const dispatch = useDispatch()
    const [token, setToken] = useState()
    const [isOpen, setIsOpen] = useState(false);
    const [navSetting, setNavSetting] = useState(false)
  
    const toggle = () => setIsOpen(!isOpen);
    const logoutHandler = (e) => {
        e.preventDefault()
        axiosWithAuth()
            .get('/logout')
            .then(res => {
                dispatch({type: LOGOUT, payload: 'You have sucessfully logged out'})
            })
            .catch(err => {
            })
            .finally(()=> {
                window.localStorage.removeItem('token')
                setToken('')
                history.push('/login')
            })
    }
    useEffect(()=>{
        setToken(window.localStorage.getItem('token'))
    })

    useEffect(()=> {
        if (token){
            dispatch({type: LOADING, payload: ''})
            axiosWithAuth()
                .get('/users/userinfo')
                .then(res => {
                    dispatch({type: LOG_IN, payload:res.data})
                })
                .catch(err => {
                    window.localStorage.removeItem('token')
                    setToken(window.localStorage.removeItem('token'))
                    dispatch({type: LOGOUT, payload: ''})
                })
                .finally(() => {
                    dispatch({type: LOADING_OFF, payload: ''})
                })
        }
    },[token])

    const backgroundChange = () => {
        setIsOpen(false)
        if (window.scrollY > 67) {
            setNavSetting(true)
        } else {
            setNavSetting(false)
        }
    }

    const stopLoading = () => {
        setIsOpen(false)
        dispatch({type: LOADING_OFF, payload: ''})
        dispatch({type: ERROR, payload: ''})
    }

    window.addEventListener('scroll', backgroundChange)

    return (
        <StyledNavbar className='navbar navbar-light sticky-top' expand="md" navSetting={navSetting}>
            <div>
                <NavbarBrand>
                    <Link to="/" onClick={stopLoading} style={{textDecoration: 'none', color: 'green', fontWeight: 'bold', alignSelf: 'center', fontSize: "110%"}}>NORTH GWINNETT HIGH SCHOOL</Link>
                </NavbarBrand>
            </div>
                <NavbarBrand>
                    <Link to="/" onClick={stopLoading} style={{textDecoration: 'none', color: 'green', fontWeight: 'bold', fontSize: "110%"}}>ENVIRONMENTAL CLUB</Link>
                </NavbarBrand>
            <Div>
                <NavbarToggler onClick={toggle}/>
                <Collapse isOpen={isOpen} navbar>
                    <Nav className="d-flex justify-content-around" navbar style={{innerWidth: "100%"}}>
                        <StyledNavItem>
                            <Link to="/" onClick={stopLoading} style={{textDecoration: 'none', color: 'black', alignSelf: 'start', marginLeft: '0'}}>HOME</Link>
                        </StyledNavItem>
                        <StyledNavItem>
                            <Link to="/about" onClick={stopLoading} style={{textDecoration: 'none', color: 'black'}}>ABOUT</Link>
                        </StyledNavItem>
                        <StyledNavItem>
                            <Link to="/event" onClick={stopLoading} style={{textDecoration: 'none', color: 'black'}}>EVENT</Link>
                        </StyledNavItem>
                        {!token ? 
                            <StyledNavItem>
                                <Link to="/login" onClick={stopLoading} style={{textDecoration: 'none', color: 'black'}}>LOGIN</Link>
                            </StyledNavItem>
                            :
                            <StyledNavItem>
                                <Link to="/profile" onClick={logoutHandler} style={{textDecoration: 'none', color: 'black', minWidth: '100px'}}>SIGN OUT</Link>
                            </StyledNavItem>
                        }
                    </Nav>
                </Collapse>
            </Div>
      </StyledNavbar>
    )
}

export default NavBar